<template>
  <SvgoLogotypeDrAlexisGranite :font-controlled="false" />
</template>
